import FooterNavbar from "../../../footernavbar/FooterNavbar";
import OurWorkplaceNavbar from "./OurWorkplaceNavbar";

const EmployeeBenifits = () => {
  return (
    <>
      <div className=" display-max">
        <FooterNavbar />
        <OurWorkplaceNavbar />
        <div className="mt-3 py-3">
          <div className="row">
            <div className="container">
              <div className="col-lg-12 justify-content-center text-center ">
                <span className="badge rounded-pill badge-warning text-white text-capitalize mb-2">
                  Employee Benefits
                </span>
                <h1 className=" text-black source-serif-4 text-normal mt-2">
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  Employee benefits fuel innovation by fostering <br /> a
                  healthy and motivated workforce.{" "}
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                </h1>
              </div>
            </div>
          </div>
          <div className="w-60 h-50 mx-auto mt-4">
            <div className="d-block blur-shadow-image">
              <img
                src="../../assets/img/footer/employeebenifits.jpg"
                alt="img-blur-shadow-blog-2"
                className="img-full "
                loading="lazy"
              />
            </div>
          </div>
        </div>
        <div className="row w-70 d-flex justify-content-center mx-auto pt-0">
          <section className="py-0">
            <div className="container">
              <div className="row align-items-center">
                <div className="container col-lg-12 col-md-6 position-relative mb-sm-0 mb-3">
                  <p className="mb-3 fs-4 container text-black">
                    At Sworld solutions private limited, we understand that our
                    employees are our greatest asset. To attract and retain top
                    talent, we offer a comprehensive benefits package designed
                    to support their health, well-being, and work-life balance.
                    Our goal is to create a positive and supportive environment
                    where our team members can thrive both personally and
                    professionally.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section className="py-5">
            <div className="container">
              <div className="row">
                <h1 className=" text-black source-serif-4 justify-content-center text-center mb-6 text-normal mt-2">
                  <sup>
                  <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  Comprehensive Health and Wellness Benefits
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                </h1>
                <div className="col-lg-6 col-10 d-flex justify-content-center flex-column  text-lg-start text-center">
                  <div className="mb-3">
                    <h2 className="mb-3 text-black fw-bold">
                      1. Health Insurance :
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      We provide comprehensive health insurance plans that cover
                      medical, dental, and vision care. Our plans offer a range
                      of options to ensure that employees can choose the
                      coverage that best meets their needs and those of their
                      families.
                    </p>
                  </div>
                  <div>
                    <h2 className="mb-3 text-black fw-bold ">
                      2. Mental Health Support :
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      We recognize the importance of mental health and offer
                      resources such as counseling services, mental health days,
                      and wellness programs to support our employees' emotional
                      well-being.
                    </p>
                  </div>
                  <div>
                    <h2 className="mb-3 text-black fw-bold ">
                      3. Wellness Programs :
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      Our wellness programs include gym memberships, fitness
                      classNamees, and health workshops to encourage a healthy
                      and active lifestyle. We also offer regular health
                      screenings and flu shots to keep our team in top
                      condition.
                    </p>
                  </div>
                </div>
                <div className="col-lg-1"></div>
                <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                  <img
                    className="w-100 border-radius-lg shadow"
                    src="../../assets/img/footer/eb-1.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </section>
          <section className="py-5">
            <div className="container">
              <div className="row">
                <h1 className=" text-black source-serif-4 justify-content-center text-center mb-6 text-normal mt-2">
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  Generous Parental Leave and Family Support
                  <sup>
                  <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                </h1>
                <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                  <img
                    className="w-100 border-radius-lg shadow"
                    src="../../assets/img/footer/eb-2.jpg"
                    alt=""
                  />
                </div>
                <div className="col-lg-1"></div>
                <div className="col-lg-6 col-10 d-flex justify-content-center flex-column  text-lg-start text-center">
                  <div className="mb-3">
                    <h2 className="mb-3 text-black fw-bold">
                      1. Parental Leave :
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      We offer generous parental leave policies for both new
                      mothers and fathers, allowing them to take the time they
                      need to bond with their new child and adjust to their
                      growing family. Our parental leave is designed to be
                      flexible and supportive, ensuring that employees can
                      balance their work and family responsibilities.
                    </p>
                  </div>
                  <div>
                    <h2 className="mb-3 text-black fw-bold ">
                      2. Family-Friendly Policies
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      Our family-friendly policies include flexible work
                      arrangements, such as remote work options and flexible
                      hours, to help employees manage their family commitments.
                      We also provide resources and support for childcare,
                      including referrals to local childcare providers and
                      emergency backup care options.
                    </p>
                  </div>
                  <div>
                    <h2 className="mb-3 text-black fw-bold ">
                      3. Adoption Assistanc
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      We offer financial assistance for employees who are
                      adopting a child, helping to cover adoption-related
                      expenses and providing additional leave to support the
                      transition.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="py-5">
            <div className="container">
              <div className="row">
                <h1 className=" text-black source-serif-4 justify-content-center text-center mb-6 text-normal mt-2">
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  Financial Security and Career Development
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                </h1>
                <div className="col-lg-6 col-10 d-flex justify-content-center flex-column  text-lg-start text-center">
                  <div className="mb-3">
                    <h2 className="mb-3 text-black fw-bold">
                      1. Retirement Savings Plan :
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      We offer a robust retirement savings plan with company
                      matching contributions to help employees plan for their
                      future. Our financial advisors are available to provide
                      guidance on retirement planning and investment strategies.
                    </p>
                  </div>
                  <div>
                    <h2 className="mb-3 text-black fw-bold ">
                      2. Competitive Salaries and Bonuses :
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      Our compensation packages include competitive salaries and
                      performance-based bonuses, ensuring that our employees are
                      rewarded for their hard work and dedication.
                    </p>
                  </div>
                  <div>
                    <h2 className="mb-3 text-black fw-bold ">
                      3. Professional Development :
                    </h2>
                    <p className="mb-3 fs-4 container text-black">
                      We are committed to the growth and development of our
                      employees. We offer a range of professional development
                      opportunities, including training programs, workshops, and
                      conferences, as well as access to online learning
                      platforms.
                    </p>
                  </div>
                </div>
                <div className="col-lg-1"></div>
                <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                  <img
                    className="w-100 border-radius-lg shadow"
                    src="../../assets/img/footer/eb-3.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </section>
          <section className="py-5">
            <div className="container">
              <div className="row">
                <h1 className=" text-black source-serif-4 justify-content-center text-center mb-6 text-normal mt-2">
                  <sup>
                  <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  Work-Life Balance and Employee Perks
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                </h1>
                <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                  <img
                    className="w-100 border-radius-lg shadow"
                    src="../../assets/img/footer/eb-4.jpg"
                    alt=""
                  />
                </div>
                <div className="col-lg-1"></div>
                <div className="col-lg-6 col-10 d-flex justify-content-center flex-column  text-lg-start text-center">
                  <div className="mb-2">
                    <h3 className="mb-3 text-black fw-bold">
                      1. Flexible Work Arrangements :
                    </h3>
                    <p className="mb-3 fs-5 container text-black">
                      To support work-life balance, we offer flexible work
                      arrangements, including remote work options and flexible
                      hours. This allows employees to manage their personal and
                      professional commitments more effectively.
                    </p>
                  </div>
                  <div>
                    <h3 className="mb-3 text-black fw-bold ">
                      2. Paid Time Off :
                    </h3>
                    <p className="mb-3 fs-5 container text-black">
                      Our generous paid time off (PTO) policy includes vacation
                      days, personal days, and paid holidays. We encourage our
                      employees to take time off to relax and recharge.
                    </p>
                  </div>
                  <div>
                    <h3 className="mb-3 text-black fw-bold ">
                      3. Employee Discounts :
                    </h3>
                    <p className="mb-3 fs-5 container text-black">
                      Employees enjoy discounts on our products and services,
                      allowing them to benefit from the high-quality offerings
                      of Sworld.
                    </p>
                  </div>
                  <div>
                    <h3 className="mb-3 text-black fw-bold ">
                      4. Company Events and Activities :
                    </h3>
                    <p className="mb-3 fs-5 container text-black">
                      We regularly organize company events and activities, such
                      as team-building retreats, social gatherings, and
                      volunteer opportunities, to foster a sense of community
                      and camaraderie among our team members.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <section className="py-6">
          <div className="row">
            <div className="container">
              <div className="col-lg-12 justify-content-center text-center ">
                <h1 className=" text-black source-serif-4 text-normal mt-2">
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  Creating a Supportive and Inclusive Workplace
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                </h1>
                <h4 className=" text-black source-serif-4 text-normal mt-2">
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-l text-dark text-lg"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  At Sworld solutions private limited, we are dedicated to
                  creating a supportive and inclusive workplace where all
                  employees feel valued and respected. <br /> Our benefits
                  package reflects our commitment to the well-being of our team
                  members, ensuring that they have the resources and support
                  they need to succeed both at work and in their personal lives.{" "}
                  <br />
                  By investing in our employees' health, happiness, and
                  professional growth, we create a thriving workplace that
                  drives our success and allows us to deliver exceptional
                  products and services to our customers. <br />
                  Join us at Sworld and experience the benefits of being part of
                  a company that truly cares about its people.
                  <sup>
                  <i
                      className="ri-double-quotes-r text-dark text-lg"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                </h4>
              </div>
            </div>
          </div>
          <div className="w-60 h-50 mx-auto mt-4">
            <div className="d-block blur-shadow-image">
              <img
                src="../../assets/img/footer/eb-5.jpg"
                alt="img-blur-shadow-blog-2"
                className="img-full "
                loading="lazy"
              />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default EmployeeBenifits;
